(function () {
  'use strict';

  var root = document.querySelector('[data-zwc-root]');
  if (!root) return;

  var savedY = null;

  function capture() {
    savedY = window.scrollY || window.pageYOffset || 0;
  }

  /* Capture scroll position on any filter interaction (checkbox, toggle, range) */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-zwc-sidebar]')) capture();
  }, true);

  /* Capture on range slider drag (price filter) */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-zwc-range]')) capture();
  }, true);

  /* Capture on pill removal, clear links, occasion buttons, toolbar sort */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (
      e.target.closest('.zwc-active-pill') ||
      e.target.closest('[data-zwc-clear]') ||
      e.target.closest('[data-zwc-occasion]') ||
      e.target.closest('.zwc-toolbar, [data-zwc-toolbar]')
    ) {
      capture();
    }
  }, true);

  /* Restore after the AJAX filter re-render completes */
  function restore() {
    if (savedY === null) return;
    var y = savedY;
    savedY = null;

    requestAnimationFrame(function () {
      var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo({ top: Math.min(y, maxY), left: 0, behavior: 'auto' });

      /* Second pass after layout/images settle */
      requestAnimationFrame(function () {
        var maxY2 = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        window.scrollTo({ top: Math.min(y, maxY2), left: 0, behavior: 'auto' });
      });
    });
  }

  document.addEventListener('zwc:rerender', restore);

  /* Prevent browser scroll-anchoring from jumping during the grid DOM swap */
  var wrap = root.querySelector('[data-zwc-grid-wrap]');
  if (wrap) wrap.style.overflowAnchor = 'none';
})();